
const format = (str,args) => {
    let i = 0;
    return str.replace(/{}/g, () => {
        return typeof args[i] !== 'undefined' ? args[i++] : '';
    });
}


const StrFormat = (props) => {
    return format(props.str,props.args);
}

export default StrFormat;



// WEBPACK FOOTER //
// ./src/components/StrFormat/index.js